// extracted by mini-css-extract-plugin
export default {"icon":"styles_icon__HYhOj","containerSearch":"styles_containerSearch__IDe7M","header":"styles_header__mb-cD"};